import { Row, Col, Button, Image } from "react-bootstrap"
import useWindowDimensions from "../../../utils/useWindowDimensions";
import { scroller } from 'react-scroll';
import { Link } from 'react-router-dom'


import proposingBanner from "../../../assets/images/vote.png"

import styles from "./DeliveryBizConnectHeader.module.css";

const scrollToSection = () => {
    scroller.scrollTo('homePageVotingSection', { //check Voting.js to find this class
        duration: 0,
        delay: 0,
        smooth: "easeInOutQuart",
    });
}

function DeliveryBizConnectHeader() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.headerTitleVote}>VOTE FOR</div>
                    <div className={styles.headerTitle}>Save our Restaurants and Reduce Pollution of Single Deliveries</div>
                    <div className={styles.headerSubtext}>Match 20, 2022 Period</div>
                    <Button className={styles.headerButtons} onClick={() => scrollToSection()}>
                        <div className={styles.headerButtonText}>Vote Now</div>
                    </Button>
                    <br></br>
                    <Button className={styles.headerVoteButton} onClick={() => window.open("https://deliverybizconnect.com")}>
                        <div className={styles.headervoteButtonText}>DeliveryBizConnect Website</div>
                    </Button>
                    {width < 992 ?
                        <Col>
                            <Link to="buy-voton">
                                <Button className={styles.headerButtons} onClick={() => scrollToSection()}>
                                    <div className={styles.headerButtonText}>Buy Token</div>
                                </Button>
                            </Link>
                        </Col> : <></>}
                    {width < 992 ?
                        <Col>
                            <Image src={proposingBanner} className={styles.votingBanner}></Image>
                        </Col>
                        : <></>
                    }
                </div>
            </Col>
        </Row>
    );
}

export default DeliveryBizConnectHeader;
